import React, { memo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ImageZoom, FileIconLink, ImageUnavailable } from 'ui-kit';
import { getFileInfo } from 'utils/custom';
import { isImageExtension } from 'utils/custom/getFileFormat';

const FilePreview = ({ value, zoom }) => {
  const { name, path } = getFileInfo(value);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(false);
  }, [path]);

  if (!name || !path) return null;

  if (isImageExtension(name)) {
    if (hasError) {
      return <ImageUnavailable name={name} />;
    }
    return (
      <div>
        <ImageZoom src={path} zoom={zoom} alt={name} onError={() => setHasError(true)} />
        <p>{name}</p>
      </div>
    );
  }

  return <FileIconLink value={value} />;
};

FilePreview.propTypes = {
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
  zoom: PropTypes.bool,
};

FilePreview.defaultProps = {
  value: null,
  zoom: true,
};

export default memo(FilePreview);
